"use client"
import { BlockType } from '@/libs/types'
import React from 'react'
import { OverlayTrigger, Tooltip } from "react-bootstrap"

interface ContentMetadataProps extends BlockType {
    locale: string
}

const ContentMetadata: React.FC<ContentMetadataProps> = ({
    locale,
    metadata
}) => {
    return (
        <>
            <div className="content-one-tooltip">
                <OverlayTrigger placement="right" overlay={(
                    <Tooltip id="pricing-partner-one" className="explaination" arrowProps={
                        {
                            style: {
                                backgroundColor: "#FFF",
                                opacity: 1
                            }
                        }
                    }>
                        {(!!metadata?.pricing && metadata.pricing.length !== 0) && metadata?.pricing.map((pricing: any, index: number) => {
                            return (
                                <div key={index} className="mb-4">
                                    <p className="fw-bold mb-3">
                                        {pricing.label}
                                    </p>
                                    {pricing?.data?.map((config: any, i: number) =>
                                        <p key={i} className="fw-bold mb-2">
                                            {`${config?.key ? `${config?.key}:` : ''}` + ' ' + `${config.value}` + `${i + 1 !== pricing?.data?.length ? ";" : "."}`}
                                        </p>
                                    )}
                                </div>
                            )
                        })}
                    </Tooltip>)}>
                    <span className="pricing-tips">{locale === "en-US" ? "See Pricing" : "Xem giá cả"}</span>
                </OverlayTrigger>
                <p className="d-flex">
                    {locale === "vi-VN" ? "Phí tích hợp bổ sung có thể được áp dụng." : "Additional integration fees may apply."}
                </p>
            </div>
        </>
    )
}

export default ContentMetadata